<script lang="ts" setup>
import { ImagePromptItem } from "@/stores/prompts";

defineProps<{
  list: ImagePromptItem[];
  selectedTagMap: Map<number, ImagePromptItem>;
  level: number;
}>();
const emit = defineEmits<{
  (e: "promptClick", tag: ImagePromptItem): void;
}>();
</script>
<template>
  <template v-for="tag in list" :key="tag.id">
    <div v-if="tag.children.length > 0" class="w-full">
      <div class="p-2 font-bold">{{ tag.displayText }}</div>
      <div class="flex flex-wrap gap-1">
        <prompts-category
          :list="tag.children"
          :selectedTagMap="selectedTagMap"
          @prompt-click="emit('promptClick', $event)"
          :level="level + 1"
        />
      </div>
    </div>
    <div
      v-else
      class="badge m-1 h-fit rounded-xl text-xs sm:text-sm"
      :class="{
        'badge-primary': selectedTagMap.has(tag.id),
      }"
      @click="emit('promptClick', tag)"
    >
      {{ tag.displayText }}
    </div>
  </template>
</template>
